exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[alt=\"black-diamond\"][data-v-e9a48cb4] {\n  -webkit-filter: invert(0.2);\n          filter: invert(0.2);\n}\nimg[alt=\"pearl\"][data-v-e9a48cb4] {\n  -webkit-filter: invert(1);\n          filter: invert(1);\n}\n", ""]);

// exports
